import { documentCurrencyLabel } from '../../utils/documentCurrency';

/** Identifica la moneda de ingreso del comprobante en listados. */
const ListCurrencyBadge = ({ currency, className = '' }) => {
  const code = documentCurrencyLabel(currency);
  const isUsd = code === 'USD';

  return (
    <span
      className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide ${
        isUsd ? 'bg-amber-100 text-amber-900' : 'bg-slate-100 text-slate-700'
      } ${className}`}
      title={isUsd ? 'Dólares (USD)' : 'Soles (PEN)'}
    >
      {code}
    </span>
  );
};

export default ListCurrencyBadge;
